<template lang="pug">
  .contacts-form.form
    notification-modal(
      v-if="notificationModal"
      @close="notificationModal = false"
      :text="notificationModalText"
    )
    .contacts-form__elem
      .form-elem
        .form-elem__title Выбрать тип обращения
        .form-elem__body
          simple-select-form(
          :list-data="feedbackTypes"
          :default-value="defaultFeedbackType"
          @onChangeDefaultValue="changeDefaultValue"
          )
    .contacts-form__container
      .contacts-form__elem
        .form-elem(
        :class="{ 'form-elem_error' : requireErrors.name }"
        )
          .form-elem__title Имя
          .form-elem__body
            input.input.input_full(
              v-model="name"
              v-on:keyup="keymonitor"
              maxlength="50"
            )
      .contacts-form__elem
        .form-elem(
        :class="{ 'form-elem_error' : requireErrors.contacts }"
        )
          .form-elem__title Email или телефон
          .form-elem__body
            input.input.input_full(
              v-model="contacts"
              v-on:keyup="keymonitor"
              maxlength="50"
            )
    .contacts-form__elem
      .form-elem(
      :class="{ 'form-elem_error' : requireErrors.text }"
      )
        .form-elem__title Сообщение
        .form-elem__body
          textarea.textarea.textarea_full(
            v-model="text"
            v-on:keyup="keymonitor"
          )
    .contacts-form__elem
      .form-elem
        .form-elem__body
          attach-file(
            :attachments="contactAttachments"
            attachment-type="contact_attachments"
            @onChangeAttachments="changeAttachments"
          )
    .contacts-form__elem.form__elem_button
      .form-elem
        .form-elem__body
          button.button.button_paint-main.button_long(
            type="submit"
            @click.prevent="onSendForm"
          ) Отправить
        .form-elem__error(v-show="showError") Не все поля заполнены
</template>

<script>
import MainFooter from "@/components/footer/Footer.vue";
import {mapActions, mapState} from "vuex";
import SimpleSelectForm from "@/components/simpleSelectForm/SimpleSelectForm";
import NotificationModal from "../../../../components/modals/NotificationModal";
import AttachFile from "@/components/attach-file/AttachFile";

export default {
  name: "ContactsForm",
  components: {
    NotificationModal,
    SimpleSelectForm,
    MainFooter,
    AttachFile
  },
  data() {
    return {
      name: "",
      contacts: "",
      text: "",
      form_type: 1,
      contactAttachments: [],
      feedbackTypes: [],
      defaultFeedbackType: "",
      notificationModal: false,
      notificationModalText:
        "Ваше сообщение отправлено. Спасибо за обратную связь!",
      requireErrors: {
        name: false,
        contacts: false,
        text: false
      },
      showError: false
    };
  },
  computed: {
    ...mapState(["catalogue"])
  },
  methods: {
    ...mapActions(["sendContactForm"]),
    changeAttachments(data) {
      this.contactAttachments = data.value;
      this.keymonitor({});
    },
    keymonitor(e) {
      if (e.keyCode === 13) {
        return;
      }
      Object.keys(this.requireErrors).map(error => {
        this.requireErrors[error] = false;
        return error;
      });
      this.showError = false;
    },
    checkRequires() {
      const errors = [];
      const requires = Object.keys(this.requireErrors);
      requires.map(_require => {
        const require = _require.split(".");
        if (this[require] === null || this[require].length === 0) {
          errors.push(...require);
        }
      });
      errors.map(error => {
        this.requireErrors[error] = true;
        return error;
      });
      return errors.length > 0;
    },
    onSendForm() {
      if (this.checkRequires()) {
        this.showError = true;
        return;
      }
      this.sendContactForm({
        form_type: this.form_type,
        name: this.name,
        contacts: this.contacts,
        text: this.text,
        attachments: this.contactAttachments.map(el => el.id)
      }).then(response => {
        if (response.status === 200) {
          this.notificationModal = true;
          this.name = "";
          this.contacts = "";
          this.text = "";
          this.form_type = 1;
          this.contactAttachments = [];
        }
      });
    },
    changeDefaultValue(value) {
      this.defaultFeedbackType = value.text;
      this.form_type = value.value;
    }
  },
  mounted() {
    this.feedbackTypes = this.catalogue.feedbackTypes;
    this.defaultFeedbackType = this.feedbackTypes[0].text;
  }
};
</script>
